export default "__VITE_ASSET__C5hmkrN7__"